<template>
	<div class="fronthome">
		<div class="banner" id="banner">
			<div class="banner_content">
				<!--<div class="swiper-container swiper1">-->
					<!--<div class="swiper-wrapper">-->
						<!--<div class="swiper-slide">-->
							<!--<img src="../../../assets/images/front/banner1.png" alt="">-->
						<!--</div>-->
						<!--<div class="swiper-slide">-->
							<!--<img src="../../../assets/images/front/banner2.png" alt="">-->
						<!--</div>-->
						<!--<div class="swiper-slide">-->
							<!--<img src="../../../assets/images/front/banner3.png" alt="">-->
						<!--</div>-->
					<!--</div>-->
					<!--<div class="pagination swiper1pagination"></div>-->
					<!--<div class="swiper-button-prev swiper-button-white"></div>-->
					<!--<div class="swiper-button-next swiper-button-white"></div>-->
				<!--</div>-->
				<el-carousel :height="bannerHeight+'px'">
					<el-carousel-item v-for="key in banners" :key="key">
						<img :src="key" alt="">
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>

		<section class="describe">
			<div class="describe_img">
				<img  src="../../../assets/images/front/describe_shine.png" />
			</div>
			<div class="describe_title wow slideInUp">
				九科星<span style="font-size: 30px">资源</span>开放<span style="font-size: 30px">平台是什么？</span>
			</div>
			<div class="describe_con wow slideInUp">
                	九科星资源开放平台，是指九科星教学网上优质的K12教育资源，开放给广大开发者。<br />
				开发者使用所需的教学资源，以便完善自己的教育产品或项目建设，从而实现共赢。
			</div>
			<div class="describe_img2 wow slideInUp">
				<img src="../../../assets/images/front/describe_img.png" />
			</div>
		</section>

		<section class="ppjs">
			<div class="title_en">BRAND&nbsp;CORNERSTONE</div>
			<div class="ppjs_title">品牌基石</div>
			<div class="title_bottom">
				<img src="../../../assets/images/front/title_bottom.png" />
			</div>
			<div class="ppjs_con clear">
				<div class="clickbox fl lc wow slideInUp" data-wow-duration="1.5s">
					<div class="clicktitle">专业研发流程</div>
					<div class="clickcontent">精心独创“643”<br />即6审4校3通编辑模式</div>
				</div>
				<div class="clickbox fl td wow slideInUp" data-wow-duration="1.5s">
					<div class="clicktitle">专业研发团队</div>
					<div class="clickcontent">
						VIP&nbsp;&nbsp;800人<br />
						Ⅰ级&nbsp;&nbsp;2000人<br />
						常规作者&nbsp;&nbsp;5000人<br />
						专职研发人员&nbsp;&nbsp;1000人<br />
						专职研究员&nbsp;&nbsp;600人
					</div>
				</div>
				<div class="clickbox fl jg wow slideInUp" data-wow-duration="1.5s">
					<div class="clicktitle">专业研发机构</div>
					<div class="clickcontent">
						教学备考研究中心<br />
						测试评价研究中心<br />
						传媒文化研究中心<br />
						考试命题研究中心<br />
						义务教育研究中心<br />
						期刊产品研究中心<br />
						江苏产品部
					</div>
				</div>
				<div class="clickbox fl dz wow slideInUp" data-wow-duration="1.5s">
					<div class="clicktitle">个性化定制</div>
					<div class="clickcontent">
						如单独命卷和专项产品等
					</div>
				</div>
			</div>
		</section>

		<section class="djfs">
			<div class="title_en">DOCKING&nbsp;MODE</div>
			<div class="djfs_title">对接方式</div>
			<div class="title_bottom">
				<img src="../../../assets/images/front/title_bottom.png" />
			</div>
			<div class="djfs_box">
				<div class="swiper-container swiper-container1 djfs_con">
					<div class="swiper-wrapper">
						<div class="con_item swiper-slide">
							<div class="con_item_title wow slideInUp">一、直接调用资源开放平台的API接口</div>
							<div class="clear con_item_wrap">
								<div class="fl con_item_con wow slideInUp">
									<img src="../../../assets/images/front/api1.png"/>
									<div>注册成为开发者</div>
								</div>
								<div class="fl con_item_con wow slideInUp">
									<img src="../../../assets/images/front/api2.png"/>
									<div>获取资源使用权限</div>
								</div>
								<div class="fl con_item_con wow slideInUp">
									<img src="../../../assets/images/front/api3.png"/>
									<div>调用所需API</div>
								</div>
								<div class="fl con_item_con wow slideInUp">
									<img src="../../../assets/images/front/api4.png"/>
									<div>使用教学资源</div>
								</div>
							</div>
              <div class="con_item_title wow slideInUp">二、将题库组件、资源库组件集成到开发者产品中</div>
              <div class="clear con_item_wrap">
                <div class="fl con_item_con wow slideInUp">
                  <img src="../../../assets/images/front/jc1.png"/>
                  <div>注册成为开发者</div>
                </div>
                <div class="fl con_item_con wow slideInUp">
                  <img src="../../../assets/images/front/jc2.png"/>
                  <div>获取资源使用权限</div>
                </div>
                <div class="fl con_item_con wow slideInUp">
                  <img src="../../../assets/images/front/jc3.png"/>
                  <div>嵌入所需组件</div>
                </div>
                <div class="fl con_item_con wow slideInUp">
                  <img src="../../../assets/images/front/jc4.png"/>
                  <div>使用资源和系统功能</div>
                </div>
              </div>
						</div>
					</div>
				</div>
				<!--<div class="swiper-button-prev1 swiper-button-prev"></div>
	    		<div class="swiper-button-next1 swiper-button-next"></div>
				<div class="swiper-pagination1 swiper-pagination"></div>-->
			</div>
		</section>

    <section class="ptys">
      <div class="title_en">RESOURCE&nbsp;INTRODUCTION</div>
      <div class="ptys_title">资源介绍</div>
      <div class="title_bottom">
        <img src="../../../assets/images/front/title_bottom.png" />
      </div>
      <div class="ptys_con clear">
        <div class="clickbox fl lc wow slideInUp" data-wow-duration="1.5s">
          <div class="boxF">
            <div class="boxS">
              <div class="boxT">
                <div class="overlay" @click="() => {$router.push({name: 'questionBankIntroduce'})}">
                  <i class="iconfont iconshitiku"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="info">
            <h1>九科星试题库</h1>
            <div class="info-explain">试题总量超<span v-if="questionNum">{{questionNum}}</span><span v-else>720</span>万道、覆盖知识点38000余个。试题质量严格把关，正确率高达98%以上。涵盖各地区、年级学科知识点。</div>
            <!-- <router-link class="button" to="/front/introduce/question-bank">了解详情</router-link> -->
          </div>
        </div>
        <div class="clickbox fl lc wow slideInUp" data-wow-duration="1.5s">
          <div class="boxF">
            <div class="boxS">
              <div class="boxT">
                <div class="overlay" @click="() => {$router.push({name: 'resourceCenterIntroduce'})}">
                  <i class="iconfont iconziyuanzhongxin"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="info">
            <h1>资源中心</h1>
            <div class="info-explain">各类资源总量高达<span v-if="docNum">{{docNum}}</span><span v-else>300</span>万份，多年积累，数万教师精心整理上传，包括同步课件，教案，导学案，备课素材，音视频资料等。</div>
            <!-- <router-link class="button" to="/front/introduce/resource-center">了解详情</router-link> -->
          </div>
        </div>
        <div class="clickbox fl lc wow slideInUp" data-wow-duration="1.5s">
          <div class="boxF">
            <div class="boxS">
              <div class="boxT">
                <div class="overlay" @click="() => {$router.push({name: 'historyPaperIntroduce'})}">
                  <i class="iconfont iconpaper"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="info">
            <h1>历年试卷</h1>
            <div class="info-explain">试卷来源丰富，涵盖历年中高考、模拟考、期中期末考、月考、单元考。几乎覆盖全国各地区、各年级学科、教材版本。</div>
            <!-- <router-link class="button" to="/front/introduce/history-paper">了解详情</router-link> -->
          </div>
        </div>
      </div>
    </section>

		<section class="swhz">
			<div class="swhz_box">
				<div class="title_en">BUSINESS COOPERATION</div>
				<div class="swhz_title">商务合作</div>
				<div class="title_bottom">
					<img src="../../../assets/images/front/title_bottom.png" />
				</div>
				<div class="swhz_con clear">
					<div class="con_left fl ">
						<div class="left_title">联系我们</div>
						<div class="left_content">
							<div class="clear">
								<div class="con_icon phone fl">
									<img src="../../../assets/images/front/phone_icon.png" />
								</div>
								<div class="fl">商务合作 ：17719991109（宋老师）</div>
							</div>
							<div class="clear">
								<div class="con_icon QQ fl">
									<img src="../../../assets/images/front/qq_icon.png" />
								</div>
								<div class="fl">QQ：3588036337</div>
							</div>
							<div class="clear">
								<div class="con_icon QQ fl">
									<img src="../../../assets/images/front/qq_icon.png" />
								</div>
								<div class="fl">QQ：2351918274</div>
							</div>
							<div class="clear">
								<div class="con_icon local fl">
									<img src="../../../assets/images/front/local_icon.png" />
								</div>
								<div class="fl">公司地址：江西省南昌市昌北经济开发区菊圃路1818号太阳城</div>
							</div>
						</div>
					</div>
					<div class="con_right fl" >
						<div class="right_title">在线申请</div>
						<div class="right_content">
							<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="102px" class="demo-ruleForm" :label-position="labelPosition" >
								<el-form-item label="单位名称:" prop="companyName">
									<div class="label_img">
										<img src="../../../assets/images/front/company_icon.png" />
									</div>
									<el-input v-model="ruleForm.companyName" :maxlength="100"></el-input>
								</el-form-item>
								<el-form-item label="联系人:" prop="contactsName" >
									<div class="label_img">
										<img src="../../../assets/images/front/person_icon.png" />
									</div>
									<el-input v-model="ruleForm.contactsName" :maxlength="32"></el-input>
								</el-form-item>
								<el-form-item label="联系电话:" prop="contactsPhone" >
									<div class="label_img">
										<img src="../../../assets/images/front/phone_icon.png" />
									</div>
									<el-input v-model="ruleForm.contactsPhone" :maxlength="20"></el-input>
								</el-form-item>
								<el-form-item label="留言:" prop="message" >
									<div class="label_img">
										<img src="../../../assets/images/front/message_icon.png" />
									</div>
									<el-input type="textarea" v-model="ruleForm.message" :maxlength="200"></el-input>
									<div class="remind">
										（商务经理将在1-3个工作日内联系您）
									</div>
								</el-form-item>
								<el-form-item class='subbtnbox'>
									<el-button type="primary" @click="submitForm()" class="subbtn" v-loading="loading">提交</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script type="text/babel">
import commonService from '@/service/commonService'
import image from '../../../assets/images/front/banner1.png'
import image2 from '../../../assets/images/front/banner2.png'
import image3 from '../../../assets/images/front/banner3.png'
import 'animate.css'
import { WOW } from 'wowjs'

export default {
  name: 'home',
  data () {
    return {
      loading: false,
      bannerHeight: 496,
	  		ruleForm: {
        companyName: '',
        contactsName: '',
        contactsPhone: '',
        message: ''
      },
      labelPosition: 'left',
      rules: {
        companyName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        contactsName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactsPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {validator: this.$rules.telephoneNumber, trigger: 'blur'}
        ],
        message: [
          { required: false, message: '请填写留言', trigger: 'blur' }
        ]
      },
      activeName: '1',
      describe_show: true,
      banners: [image, image2, image3],
      docNum: '',
      questionNum: ''
    }
  },
  mounted () {
    const that = this
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    that.bannerHeight = 496 / 1920 * width
    window.addEventListener('resize', function () {
      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      that.bannerHeight = 496 / 1920 * width
    }, false)

    // let wow = new WOW({
    //   boxClass: 'wow',
    //   animateClass: 'animated',
    //   offset: 0,
    //   mobile: true
    // })
    // 接口没用
    // this.getDocumentNum()
    this.getQuestionNum()
    // wow.init()
  },
  destoryed () {

  },
  methods: {
    submitForm () {
      this.loading = true
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          try {
            let data = await commonService.contractUs(this.ruleForm)
            this.loading = false
            this.$message({
              message: '申请成功,我们会稍后和您联系!',
              type: 'success'
            })
            this.$refs['ruleForm'].resetFields()
          } catch (e) {
            this.$message.error(e && e.msg)
            this.loading = false
          }
        } else {
          this.loading = false
          this.$message.error('请完善您的信息')
	      }
      })
    },
    async getDocumentNum () {
      let data = await commonService.getDocumentNum()
      this.docNum = data.data.allDocumentNumbers && data.data.allDocumentNumbers.slice(0, -4)
    },
    async getQuestionNum () {
      let data = await commonService.getQuestionNum()
      this.questionNum = data.data.allDocumentNumbers && data.data.allDocumentNumbers.slice(0, -4)
    }

  }

}
</script>

<style scoped="scoped">
@import '../../../assets/css/frontHome.css';
</style>
<style>
@import 'front_home.css';
</style>



// WEBPACK FOOTER //
// src/pages/front/home/index.vue